import React, { useEffect, useRef, useState } from "react";

const pairs = [
  { name: "EUR/USD", symbol: "FX:EURUSD" },
  { name: "GBP/USD", symbol: "FX:GBPUSD" },
  { name: "USD/JPY", symbol: "FX:USDJPY" },
  { name: "USD/CHF", symbol: "FX:USDCHF" },
  { name: "AUD/USD", symbol: "FX:AUDUSD" },
];

function ForexChart() {
  const chartRef = useRef();
  const [selectedPair, setSelectedPair] = useState(pairs[0].symbol);
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const chartContainer = chartRef.current;
    chartContainer.innerHTML = ""; // Clear previous chart

    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      autosize: true,
      symbol: selectedPair,
      interval: "1",
      timezone: "Etc/UTC",
      theme: theme,
      style: "1",
      locale: "en",
      enable_publishing: false,
      hide_top_toolbar: false,
      allow_symbol_change: true,
      container_id: "tradingview_chart",
    });

    chartContainer.appendChild(script);
  }, [selectedPair, theme]);

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
        <select
          value={selectedPair}
          onChange={(e) => setSelectedPair(e.target.value)}
          className="p-2 rounded-md bg-sky-950 text-white"
        >
          {pairs.map((pair) => (
            <option key={pair.symbol} value={pair.symbol}>
              {pair.name}
            </option>
          ))}
        </select>

        <button
          onClick={() => setTheme((prev) => (prev === "dark" ? "light" : "dark"))}
          className="px-4 py-2 rounded bg-sky-950 text-white hover:bg-sky-800 transition"
        >
          Toggle {theme === "dark" ? "Light" : "Dark"} Mode
        </button>
      </div>

      <div
        id="tradingview_chart"
        ref={chartRef}
        className="w-full"
        style={{ height: "500px" }}
      ></div>
    </div>
  );
}

export default ForexChart;
